// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"33311dfb","732":"3fd897e2","977":"23a6d605"}[chunkId] + ".chunk.js";
};